import { render, staticRenderFns } from "./ResourceScroller.vue?vue&type=template&id=3bbee05d&scoped=true&"
import script from "./ResourceScroller.vue?vue&type=script&lang=js&"
export * from "./ResourceScroller.vue?vue&type=script&lang=js&"
import style0 from "./ResourceScroller.vue?vue&type=style&index=0&id=3bbee05d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbee05d",
  null
  
)

export default component.exports